<template>
  <div id="app">
    <BlockInterface v-if="loading"></BlockInterface>
    <div v-if="$store.state.auth">
      <div v-if="user">
          <Inicio />
      </div>
      <div v-else>
        <Login user="asd" />
      </div>
    </div>
    <div v-else>
      <Loading />
    </div>
    <div class="modal-mask"></div>
  </div>
</template>

<script>
import Login from "@/components/Login";
import Inicio from "@/components/views/Inicio";
import BlockInterface from "@/components/layouts/BlockInterface";
import Vuex from "vuex";
import Loading from "@/components/layouts/Loading";
import Axios from "axios";

export default {
  name: "App",
  components: {
    Login,
    Inicio,
    Loading,
    BlockInterface,
  },
  data: () => ({
    mounted: false,
    requestsCount: 0,
  }),
  computed: {
    ...Vuex.mapState(["user"]),
    loading: function(){
      if(this.requestsCount > 0){
        return true;
      }
      return false;
    }
  },
  methods: {
    ...Vuex.mapActions(["getUser"]),
  },
  created() {
    Axios.interceptors.request.use(
      (config) => {
        this.requestsCount++;
        // trigger 'loading=true' event here
        return config;
      },
      (error) => {
        // trigger 'loading=false' event here
        
        this.requestsCount--;
        return Promise.reject(error);
      }
    );
    Axios.interceptors.response.use(
      (response) => {
        // trigger 'loading=false' event here
        
        this.requestsCount--;
        return response;
      },
      (error) => {
        // trigger 'loading=false' event here
        
        this.requestsCount--;
        return Promise.reject(error);
      }
    );
  },
  mounted() {
    this.mounted = true;
    Axios.get('/institucion').then((r) => console.log(r.data)).catch((e) => {console.log(e.response)})
  },
  destroyed() {
    console.log("se ejecuta el destroyed??");
  },
};
</script>
